import { Container, Text } from './Pill.styles';

export type PillVariant = 'variant1' | 'variant2' | 'variant3' | 'variant4';

export interface PillProps {
  text: string;
  variant: PillVariant;
}

const Pill = ({ text, variant }: PillProps) => {
  return (
    <Container $variant={variant}>
      <Text>{text}</Text>
    </Container>
  );
};

export default Pill;
